// store/modules/database.js
import store from '../index.js';
import request from '../../common/request/index';
import { sub } from '../../common/event.js';

export default {
  namespaced: true,
  state: {
    list: [],
  },
  mutations: {
    setList: (state, payload) => {
      state.list = payload;
    },
  },
  actions: {
    async getList({ commit }) {
      const ret = await request.api.get(`feng/feng/alldatabse`);
      if (ret && ret.success) commit(`setList`, ret.data);
    },
  },
  init: async function () {
    const user = localStorage.getItem('user');
    if (user) store.dispatch({ type: 'database/getList', payload: {} });
    sub('loginSuccess', () => {
      store.dispatch({ type: 'database/getList', payload: {} });
    });
  },
};